import {
  BarChart,
  Bar,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  Legend,
  YAxis,
  Cell,
  Text,
} from "recharts"
import { chartColours } from "../Charts/chart-util"

function legendFormatter(fieldName) {
  return <span className="text-color-class text-xs">{fieldName}</span>
}
function massageDataIntoPayload(data) {
  return data.map((item, index) => ({
    id: item.name,
    color: chartColours[index],
    type: "rect",
    value: `${item.name}`,
  }))
}

export default function BarView({
  data,
  tooltipContent,
  formatter,
  printAsPDF,
  colour,
  yAxisLabel,
  includeLegend = true,
  includeXaxisTicks = false,
  singleColour,
}) {
  const maxValue = formatter(data[0].value) || formatter(0)
  const additionalWidth = maxValue.toString().split("").length * 5

  return (
    <ResponsiveContainer>
      <BarChart
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <XAxis
          dataKey="name"
          className="transform"
          tick={includeXaxisTicks}
          interval={printAsPDF ? 0 : null}
          style={{ fontSize: "12px" }}
        />
        <YAxis
          label={
            <Text
              style={{ fontSize: "12px" }}
              fill="gray"
              dx={5}
              dy={printAsPDF ? 120 : 130}
              verticalAnchor="middle"
              textAnchor="middle"
              angle={-90}
            >
              {yAxisLabel}
            </Text>
          }
          tickFormatter={formatter}
          style={{ fontSize: "12px" }}
          width={20 + additionalWidth}
        />
        <Tooltip content={tooltipContent} />
        {includeLegend && (
          <Legend
            payload={massageDataIntoPayload(data)}
            layout="horizontal"
            align="bottom"
            verticalAlign="bottom"
            wrapperStyle={{
              fontSize: "12px",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
            fill={colour}
            formatter={(value) => legendFormatter(value)}
          />
        )}
        <Bar
          dataKey="value"
          fill={colour}
          isAnimationActive={false}
          radius={[5, 5, 0, 0]}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={singleColour || chartColours[index]}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}
